/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrders200ResponseOrdersInnerProviderStatusInner
 */
export interface GetOrders200ResponseOrdersInnerProviderStatusInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerProviderStatusInner
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerProviderStatusInner
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerProviderStatusInner
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerProviderStatusInner
     */
    carrier?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerProviderStatusInner
     */
    trackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerProviderStatusInner
     */
    trackingUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerProviderStatusInner
     */
    deliveryDate?: string;
}

/**
 * Check if a given object implements the GetOrders200ResponseOrdersInnerProviderStatusInner interface.
 */
export function instanceOfGetOrders200ResponseOrdersInnerProviderStatusInner(value: object): value is GetOrders200ResponseOrdersInnerProviderStatusInner {
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    return true;
}

export function GetOrders200ResponseOrdersInnerProviderStatusInnerFromJSON(json: any): GetOrders200ResponseOrdersInnerProviderStatusInner {
    return GetOrders200ResponseOrdersInnerProviderStatusInnerFromJSONTyped(json, false);
}

export function GetOrders200ResponseOrdersInnerProviderStatusInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrders200ResponseOrdersInnerProviderStatusInner {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'],
        'provider': json['provider'],
        'status': json['status'] == null ? undefined : json['status'],
        'carrier': json['carrier'] == null ? undefined : json['carrier'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'trackingUrl': json['trackingUrl'] == null ? undefined : json['trackingUrl'],
        'deliveryDate': json['deliveryDate'] == null ? undefined : json['deliveryDate'],
    };
}

export function GetOrders200ResponseOrdersInnerProviderStatusInnerToJSON(json: any): GetOrders200ResponseOrdersInnerProviderStatusInner {
    return GetOrders200ResponseOrdersInnerProviderStatusInnerToJSONTyped(json, false);
}

export function GetOrders200ResponseOrdersInnerProviderStatusInnerToJSONTyped(value?: GetOrders200ResponseOrdersInnerProviderStatusInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'provider': value['provider'],
        'status': value['status'],
        'carrier': value['carrier'],
        'trackingNumber': value['trackingNumber'],
        'trackingUrl': value['trackingUrl'],
        'deliveryDate': value['deliveryDate'],
    };
}

